export abstract class AbstractSeminarActionService{
    abstract bookmarkSeminar(seminarId: string, isBookmarked: boolean): void;
    abstract likeSeminar(seminarId: string, isLiked: boolean): void;
    abstract enrollForSeminar(seminarId: string, enrollmentStatus: number): void;
    abstract removeFromCart(seminarId: string, enrollmentStatus: number): void;
    abstract showInterestCourse(courseId: string, isShowInterest: boolean): void;
}